<template>
  <div>
    <h1>{{$t('offers.list.marketplace')}}</h1>
    <div class="mb-1" v-html="$t('offers.list.description.text1', {questionPool: questionPool, minRemainingQuestions: minRemainingQuestions})"></div>
    <div class="mb-3" v-if="getMissingPool() > 0" v-html="$t('offers.list.description.text2', {missingPool: getMissingPool()})"></div>
    <div class="mb-3" v-else v-html="$t('offers.list.description.text3')"></div>
    <router-link :to="{name: 'TransactionList'}">{{$t('transactions.title')}}</router-link>
    <div class="text-center mb-3">
        <paypal-btn
          :offer="selectedOffer"
          :locale="locale"
          @payment-authorized="unsetOffer()"
        ></paypal-btn>
    </div>
    <div class="row">
      <div v-for="(offer, index) in offers" :key="index" class="col-lg-4 col-md-6 mb-4">
        <div :id="'not_purchasable_' + index">
          <button class="btn btn-block p-4"
            :disabled="!offer.purchasable"
            :class="'btn-' + (selectedOffer === offer ? 'primary' : 'light')"
            @click="selectOffer(offer)">
            <h4>
              <font-awesome-icon icon="heart"/>
              {{ offer.questionNumber }} {{$t('offers.list.question')}}
            </h4>
            <h4>{{ offer.price }} €</h4>
          </button>
        </div>
        <b-tooltip :target="'not_purchasable_' + index" v-if="!offer.purchasable">
          {{ $t('offers.notPurchasable') }}
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Pagination from '../app/Pagination';
import PaypalBtn from './PaypalButton';

export default {
  data() {
    return {
      errorMessage: null,
      paymentSuccess: false,
      selectedOffer: null
    }
  },
  components: { Pagination, PaypalBtn },
  computed: mapGetters({
    offers: "offer/list/items",
    locale: "user/auth/locale",
    minRemainingQuestions: "user/auth/minRemainingQuestions",
    questionPool: "app/giveAway/questionPool",
  }),
  methods: {
    ...mapActions({
      getPage: "offer/list/getPaidItems"
    }),
    selectOffer(offer) {
      this.selectedOffer = offer;
    },
    getMissingPool() {
    	return this.minRemainingQuestions - this.questionPool;
    },
	  unsetOffer() {
    	this.selectedOffer = null;
    }
  },
  created() {
    this.$store.dispatch('app/giveAway/getGiveAwayQuestion');
    this.$store.dispatch("offer/list/getPaidItems");
    this.$store.dispatch("user/auth/getMinRemainingQuestions");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketplace/MarketPlace.vue